import React, { useState } from 'react'
import { resetIcon, expandAppliedFilterMobile } from '../../assets';
import './GenAIFilterDisplay.css';

const formattedStringArr = (array, fn) => {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        var mapping = fn(array[i].replaceAll('☼', '|'));
        if (i === array.length - 1) {
            result = result.concat(array[i].replaceAll('☼', '|'));
        }
        else {
            result = result.concat(mapping);
        }
    }
    return result;
}
const renderSubFilters = (facet, handleRemoveAppliedFilter) => (subFilter, key) => <>
    <div key={key} className="gen-ai-filter-display__tag" role="button" >
        <span className="gen-ai-filter-display__tag-text" title={subFilter}>{formattedStringArr(subFilter.replaceAll('|', '☼').replaceAll('/', '|').split('|'), function (part) {
            return [part, <span> | </span>];
        })}</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { handleRemoveAppliedFilter(facet + '/' + subFilter) }}>
            <title>{`Remove ${subFilter}`}</title>
            <path d="M12 4L4 12M4 4L12 12" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        {/* <img src={popCancelBttn} alt='' className='remove-filter clickable' title={`Remove ${subFilter}`} onClick={() => { handleRemoveAppliedFilter(facet + '/' + subFilter) }} /> */}
    </div>
</>
export default function GenAIFilterDisplay(props) {
    const [showFilters, setShow] = useState(true);
    const {
        appliedFilters,
        handleClearFilters,
        handleRemoveAppliedFilter,
        customWidth
    } = props;

    const cls = `gen-ai-filter-display`.trim();

    //const service = new FilterService()
    //const reducedFilters = service.condenseFilterSet(allFilters,appliedFilters)
    const displayFilters = {}
    appliedFilters.forEach(filter => {
        const filterParts = filter.split('/')
        const filterTop = filterParts.shift()
        displayFilters[filterTop] = displayFilters[filterTop] || []
        displayFilters[filterTop].push(filterParts.join('/'))
    })
    const onHide = () => {
        setShow(!showFilters)
    }
    if (customWidth <= 600) {
        return (
            <div className="filter-selection-display-wrapper-mobile">
                <div className="applied-filter-header-section-mobile">
                    <div className="applied-filter-header-text-mobile">Applied Filters</div>
                    <div className="applied-filters-header-icons-wrapper">
                        <div onClick={e => setShow(!showFilters)}>
                            {!showFilters ?
                                <img src={expandAppliedFilterMobile} alt="" width="22" height="22" />
                                :
                                <img src={expandAppliedFilterMobile} alt="" width="22" height="22" style={{ transform: "rotate(180deg)" }} />
                            }

                        </div>
                        <div
                            onClick={e => handleClearFilters()}
                            className="clear-all-button-mobile" title="Remove All Filters">
                            <img src={resetIcon} alt="" style={{ paddingBottom: "3%" }} />
                        </div>
                        {/* <div onClick={e=>handleClearFilters()}>
                    <img src={cancelRedIcon} alt="" width="22" height="22"/>
                </div> */}
                    </div>
                </div>
                {showFilters &&
                    <div className="filter-display-item-wrapper filter-display-item-wrapper-mobile">
                        {Object.entries(displayFilters).map(([facet, refiners], index) =>
                            <div key={index} className="facet-item-wrapper">
                                <span className="facet-inner-wrapper">
                                    {facet === 'Recently Added_Updated' ?
                                        <span className="parentFilter parentFilter-mobile">Recently Added/Updated</span> :
                                        facet === 'Document Subtypes' ?
                                            <span className="parentFilter parentFilter-mobile">{facet} (Submission-Related Documents Only)</span> :
                                            <span className="parentFilter parentFilter-mobile">{facet}</span>}
                                    <span className='subfilter-wrapper'>
                                        {refiners
                                            .map(renderSubFilters(facet, handleRemoveAppliedFilter))
                                            .reduce((elements, element) =>
                                                elements === undefined
                                                    ? element
                                                    : <>{elements} | {element}</>
                                            )
                                        }
                                    </span>
                                </span>
                            </div>
                        )}
                    </div>
                }
            </div>
        )
    }
    else {
        return (
            <div className={cls} data-property-1={"Variant2"}>
                <div className="gen-ai-filter-display__stack">
                    <div className="gen-ai-filter-display__row gen-ai-filter-display__row--header">
                        <div className="gen-ai-filter-display__title-wrap">
                            <div className="gen-ai-filter-display__title">Applied Filters</div>
                        </div>
                        <button
                            type="button"
                            className="gen-ai-filter-display__hide-btn"
                            onClick={onHide}
                            aria-pressed="false"
                        >
                            {/* <span className="gen-ai-filter-display__hide-icon" aria-hidden="true" /> */}
                            {showFilters ? <><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.33301 8H12.666" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                                <span className="gen-ai-filter-display__hide-text">Hide</span>
                            </> : <>
                                <svg width="14" height="14" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6772 17.6643L29.9082 17.6713L29.9062 14.3192L17.6753 14.3122L17.6683 2.08127L14.3162 2.07935L14.3232 14.3103L2.09206 14.3034L2.09398 17.6554L14.3251 17.6624L14.3321 29.8935L17.6842 29.8954L17.6772 17.6643Z" fill="black" />
                                </svg>
                                <span className="gen-ai-filter-display__hide-text">Show</span>
                            </>}
                        </button>
                    </div>
                    {showFilters &&
                        <>

                            <div className="gen-ai-filter-display__groups">
                                <div className="gen-ai-filter-display-reset-selection">
                                    <button
                                        onClick={handleClearFilters}
                                        className="gen-ai-filter-clear-all-button" title="Remove All Filters">
                                        <svg width="16" height="16" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                            <defs></defs><path className="gen-ai-filter-clear-all-button-cls-1" d="M11.7513,9.3206c-.5404,1.5612-2.0226,2.6827-3.7676,2.6827-2.202,0-3.9871-1.7851-3.9871-3.987s1.7851-3.987,3.9871-3.987c1.1664,0,2.2149.5015,2.9437,1.3001l-2.1224-.1018-.1558.8835,3.9265.6923.6909-3.9181-.882-.1641-.633,2.0382c-.9145-1.0566-2.2641-1.7267-3.7679-1.7267-2.7481,0-4.9838,2.2357-4.9838,4.9838s2.2357,4.9838,4.9838,4.9838c2.1717,0,4.0223-1.3968,4.7035-3.3388l-.9359-.3407Z" /></svg>
                                        Reset Selection
                                    </button>
                                </div>
                                {Object.entries(displayFilters).map(([facet, refiners], index) => (
                                    <div key={index} className="gen-ai-filter-display__group">
                                        <div className="gen-ai-filter-display__group-label-row">
                                            {facet === 'Recently Added_Updated' ?
                                                <div className="gen-ai-filter-display__group-label">Recently Added/Updated</div> :
                                                facet === 'Document Subtypes' ?
                                                    <div className="gen-ai-filter-display__group-label">{facet} (Submission-Related Documents Only)</div> :
                                                    <div className="gen-ai-filter-display__group-label">{facet}</div>}
                                        </div>
                                        <div className="gen-ai-filter-display__tags">
                                            {refiners
                                                .map(renderSubFilters(facet, handleRemoveAppliedFilter))
                                                .reduce((elements, element) => (
                                                    elements === undefined
                                                        ? element
                                                        : <>{elements}<span className='filter-divider'></span>{element}</>
                                                ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>

                    }

                </div>
            </div >
        )
    }
};